import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';

import AreasAltNamesTable from './Table';

import { getAreas } from 'actions/regions/areas';
import styles from 'styles';

class AreasAltNames extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.getAreas();
    }

    render() {
        return (
            <div id='alt-areas' className='table-page'>
                <CircularProgress
                    className={!this.props.isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={this.props.isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            areas alternative names
                        </h2>
                        <AreasAltNamesTable />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLogged: state.user.isLogged,
            isLoaded: state.areas.isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getAreas,
    },
    dispatch),
)(AreasAltNames);



// WEBPACK FOOTER //
// ./app/components/Regions/AreasAltNames/Page.jsx